<template>
  <div class="parent" ref="container">
    <div
      v-for="i in 2"
      :key="i"
      :data-text="text"
      class="container"
      :class="containerClass"
      :style="containerStyles[i]"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import RandomUtils from "@/scripts/utils/random"
import StoreUtils from "@/scripts/utils/store"
/**
 * Performs a textglitch effect
 */
export default {
  props: {
    text: String,
    parentGlitch: Boolean
  },
  watch: {
    parentGlitch(newVal) {
      if (newVal) {
        this.glitch()
      } else {
        this.unGlitch()
      }
    }
  },
  data() {
    return {
      containerClass: "",
      // holds style for container 1 and two
      containerStyles: [],
      lines: 1,
      storeWatch: null
    }
  },
  methods: {
    // sets how many lines of text we have
    setStyles() {
      let container1 = {}
      let container2 = {}
      const offset = RandomUtils.RandomNumber(10, 50)
      const setOffset = val => {
        return `${val}px`
      }

      if (RandomUtils.CoinToss()) {
        container1.left = setOffset(offset)
        container2.left = setOffset(-offset)
      } else {
        container1.left = setOffset(-offset)
        container2.left = setOffset(offset)
      }
      this.containerStyles = [container1, container2]
    },
    glitch() {
      this.setStyles()
    },
    unGlitch() {
      this.containerClass = ""
      this.containerStyles = []
    }
  },
  created() {
    // start
    this.storeWatch = StoreUtils.WatchGlitch(this.glitch, this.unGlitch)
  },
  beforeDestroy() {
    this.storeWatch()
  }
}
</script>

<style scoped lang="scss">
$shift: 5px;
$skew: 20deg;

.parent {
  position: relative;
}

.container {
}

.container:first-child {
  position: absolute;
  top: 0;
  left: 0;
  clip-path: polygon(0 50%, 100% 50%, 100% 100%, 0 100%);
}

.container:nth-child(2) {
  position: relative;
  top: 0;
  left: 0;
  clip-path: polygon(0 0, 100% 0, 100% 50%, 0 50%);
}
.glitch-container-left {
  transform: skew(-#{$skew}, 0);
}
.glitch-container-right {
  transform: skew(#{$skew}, 0);
}
</style>